// 数据回收模块
export default {
    DataRecycling: {
        DataOverview: 'Tinjauan Data',
        UpdatedOn: 'Dikemaskini Pada',
        NewToday: 'Tambahan Hari Ini',
        TotalDataVolume: 'Jumlah Data',
        AverageAnswerTime: 'Masa Purate Menjawab',
        TopicStatistics: 'Statistik Topik',
        Export: 'Eksport',
        Operate: 'Operasi',
        Preview: 'Pratonton',
        NumberOfRespondents: 'Bilangan Responden',
        Download: 'Muat Turun',
        LoadMore: 'Muat Lebih Lagi',
        ExportType: 'Jenis Eksport',
        DataReport: 'Laporan Data',
        ExportFormat: 'Format Eksport',
        ExportCSV: 'Eksport ke CSV',
        ExportToExcel: 'Eksport ke Excel',
        ExportWord: 'Eksport ke Word',
        Export: 'Eksport',
        ModifyQuestionnaireTip: 'Adakah anda pasti mahu mengubahsuai kaji selidik ini? Semua pengumpulan data kaji selidik ini akan dihentikan, dan pautan jawapan akan ditutup sementara!',
        ModificationPrompt: 'Petunjuk Pengubasuaian',
        CustomTitle: 'Tajuk Tersuai',
        Pie: 'Carta Pai',
        Histogram: 'Histogram',
        BarChart: 'Carta Bar',
        Ring: 'Sinaran',
        StackedBarChart: 'Lajur Bertindan',
        StackedBarChart: 'Bar Bertindan',
        RadarChart: 'Radar',
        DataPreparationInProgress: 'Data Sedang Disediakan, dijangka tamat dalam 5 minit. Beralih ke',
        MyDownload: 'My Download',
        CanViewProgress: 'untuk semak status muat turun',
        Referrer: 'Rujukkan',
        ExportData: 'Eksport Data',
        ExportChart: 'Eksport Carta',
        PleaseSelect: 'Sila Pilih',
        StackedColumnChart: 'Carta Lajur Bertindan',
        StackedBarChart: 'Carta Bar Bertindan',
        FoldLine: 'Polilin',
        Filter: 'Penapis',
        FilterMeetsTheFollowingCriteria: 'Penapisan Memenuhi Kriteria Berikut',
        Data: 'Data',
        AnswerToTheQuestion: 'Jawapan',
        Delete: 'Padamkan',
        ShowSatisfaction: 'Tunjukkan Kepuasan',
        AnswerSheet: 'Lembaran Jawapan',
        AddFilterCriteria: 'Tambah Kriteria Penapisan',
        AnswerDate: 'Tarikh Menjawab',
        To: 'Hingga',
        StartDate: 'Tarikh Mula',
        EndDate: 'Tarikh Akhir',
        Clear: 'Kosongkan',
        AllConditions: 'Semua Syarat',
        AnyCondition: 'Sebarang Syarat',
        All: 'Semua',
        Custom: 'Tersuai',
        Selected: 'Dipilih',
        NotSelected: 'Tidak Dipilih',
        IsEmpty: 'Kosong',
        NotEmpty: 'Tidak Kosong',
        Contain: 'Mengandungi',
        NotIncluded: 'Tidak Termasuk',
        OnlySelect: 'Hanya Pilih',
        RestoreToDefault: 'Setelah Kosongkan Penapisan, Semua Penapisan Akan Kembali kepada Bentuk Lalai',
        ConfirmEmptying: 'Pasti Kosongkan',
        LoadError: 'Ralat Muat',
        QuestionBasedStatistics: 'Statistik Berdasarkan Soalan',
        CrossAnalysis: 'Analisis Silang',
        SourceAnalysis: 'Analisis Sumber',
        SubtitleStatisticsCopy: 'Salin Statistik Sub-topik',
        DataAnalysis: 'Analisi Data',
        CrossChart: 'Carta Silang',
        AddCrossAnalysis: 'Tambah Analisi Silang',
        NotCrossChart: 'Tiada Carta Silang untuk Projek Ini',
        CrossChartsSupport: 'Carta Silang hanya menyokong soalan pilihan tunggal dan pilihan pelbagai',
        AddCrossChart: 'Tambah Carta Silang',
        Argument: 'Argumen',
        DependentVariable: 'Pembolehubah Tergantung',
        HideChart: 'Sembunyikan Carta',
        HideTable: 'Sembunyikan Jadual',
        DisplaySettings: 'Tunjukan Seting',
        TotalNumberOfInterviewees: 'Jumlah Individu yang Diwawancarai',
        RowPercentage: 'Peratusan Baris',
        ChartType: 'Jenis Carta',
        DisplayChart: 'Tunjukkan Carta',
        DisplayTable: 'Tunjukkan Jadual',
        DataScreening: 'Pemantauan Data',
        NewDataAddedToday: 'Data Baru Ditambah Hari Ini',
        DataDetails: 'Butiran Data',
        SetUp: 'Tetapan',
        ExportAttachments: 'Eksport Lampiran',
        ExportPicture: 'Eksport Gambar',
        ExportRecording: 'Eksport Rakaman',
        ExportContent: 'Eksport Kandungan',
        DataDetailsTable: 'Jadual Butiran Data',
        DataType: 'Jenis Data',
        RawData: 'Data Mentah',
        CodedData: 'Data Kod',
        ExhibitionFormat: 'Format Pameran',
        OneQuestionOneColumn: 'Satu Soalan Satu Lajur',
        OneQuestionWithMultipleColumns: 'Satu Soalan Dengan Beberapa Lajur',
        Details: 'Butiran',
        FullName: 'Nama',
        Age: 'Umur',
        Year: 'Tahun',
        Gender: 'Jantina',
        Education: 'Tahap Pendidikan',
        CellPhoneNumber: 'Nombor Telefon Bimbit',
        Mailbox: 'Peti Mel',
        ID: 'Nombor ID',
        Address: 'Alamat',
        SampleStatusName: 'Nama Status Sampel',
        ExportImageSettingsField: 'Medan Tetapan untuk Eksport Gambar',
        Route: 'Laluan',
        PleaseEnterContent: 'Sila Masukkan Kandungan',
        Name: 'Nama',
        LabelTip: 'Perhatian: Label muncul dalam pasangan kurungan segi empat sama. Sila beri perhatian kepada penutupan kurungan apabila memadamkan label laluan untuk memastikan kesahihan laluan.',
        State: 'Status',
        AllImages: 'Semua Imej',
        CompleteImage: 'Lengkapkan Imej',
        IdentifyingImages: 'Mengenalpasti Imej',
        ExportRecordingSettingsFields: 'Medan Tetapan untuk Eksport Rakaman',
        RecordAll: 'Rakamkan Semua',
        CompleteRecording: 'Rakaman Lengkap',
        IdentifyingRecordings: 'Mengenalpasti Rakaman',
        Source: 'Sumber',
        Interview: 'Wawancara',
        TelephoneSurveys: 'Tinjauan Telefon',
        SetDisplayFields: 'Tetapkan Medan Paparan',
        SampleFields: 'Medan Sampel',
        WhetherToChoose: 'Pilih',
        IsItFixedOnTheLeftSide: 'Kiri Tetap',
        QuestionnaireFields: 'Medan Soal Selidik',
        VisitorField: 'Medan Pengunjung',
        GeographicalDistribution: 'Taburan Geografi',
        AccessingTheEnvironment: 'Sekitaran Wawancara',
        ByDeviceType: 'Berdasarkan Jenis Peranti',
        ByBrowser: 'Berdasarkan Pelayar',
        ByOperatingSystem: 'Berdasarkan Sistem Operasi',
        Province: 'Negeri',
        SetDisplay: 'Tetapkan Paparan',
        NumberOfRespondents: 'Bilangan Responden',
        ViewChartDisplaySettings: 'Tunjukkan Paparan Tetapan Carta',
        DisplayByTitle: 'Paparkan Derdasarkan Tajuk',
        Topic: 'Tajuk',
        DisplayAccordingToQuestionType: 'Paparkan Berdasarkan Jenis Soalan',
        
        InputTypeQuestion: 'Masukkan Jenis Soalan',
        MultipleChoiceQuestions: 'Pilih Pelbagain',
        StarRating: 'Penarafan',
        TrueOrFalse: 'Betul/Salah',
        DateSelection: 'Tarikh',
        SortQuestion: 'Penarafan Kedudukan',
        AddressLocation: 'Lokasi',
        CitySelection: 'Bandar',
        Timing: 'Masa',
        MatrixTypeQuestions: 'Soalan Jenis Matriks',
        MatrixRadioSelection: 'Matriks Pilih Satu',
        MatrixMultipleSelection: 'Matriks Pilih Pelbagai ',
        MatrixStarRating: 'Maktriks Penarafan',
        MatrixFillingInTheBlank: 'Matriks Teks Sebaris',
        FillInTheBlankWithMultipleRowsOfMatrix: 'Matriks Perenggan',
        MatrixCombination: 'Kombinasi Matriks',
        MoreQuestionTypes: 'Lebih Banyak Jenis Soalan',
        Headings: 'Pengepala',
        Paging: 'Pemisah Halaman',
        PersonalInformation: 'Maklumat Peribadi',
        SingleLineInputBox: 'Kotak Teks Sebaris',
        Career: 'Pekerjaan',
        UploadFiles: 'Muat Naik Dokumen',
        FillInTheBlankHorizontally: 'Isi Tempat Kosong Secare Menegak',
        MultipleBlankFilling: 'Isi pelbagain tempat kosong',
        CascadeQuestions: 'Soalan Bercabang',
        SpecificGravityQuestion: 'Soalan Anjakan',
        ScaleQuestions: 'Soalan Skala',
        MultilineInputBox: 'Kotak Perenggan',
        FillInTheBlanks: 'Isi Tempat Kosong',
        PictureSelection: 'Pilih Gambar',
        MultipleChoiceQuestions: 'Soalan Pilih Pelbagai',
        MultipleChoice: 'Pilih Pelbagai',
        DropDownList: 'Senarai Turunan',
        AnswerSheetDetails: 'Butir Lembaran Jawapan',
        AnswerInformation: 'Maklumat Jawapan',
        TotalScore: 'Jumlah Markah',
        TextReading: 'Bacaan Teks',
        AnswerSheetReading: 'Bacaan Lembaran Jawapan',
        ViewAttachments: 'Lihat Lampiran',
        Photo: 'Gambar',
        NoPicturesObtained: 'Tiada Gamabar Diperoleh',
        SoundRecording: 'Rakaman Bunyi',
        AudioNotSupported: 'Audio tidak disokong oleh Pelayar.',
        Positioning: 'Penyusunan',
        LocationNotObtained: 'Tiada Lokasi Diperoleh',
        IncompleteData: 'Data Tidak Lengkap, Sila Segar Semula Halaman',
        SampleNumber: 'Nombor sampel'
    },
  };